import {
  DisabledReason,
  FormCheckboxControl,
  ValidationError,
  WithOptionalFieldTree,
} from '@angular/forms/signals';
import { Component, input, model, TemplateRef } from '@angular/core';

@Component({ template: '' })
export abstract class AbstractToggleSignalInput implements FormCheckboxControl {
  readonly label = input<string>();
  readonly labelTemplate = input<TemplateRef<{ $implicit: string }>>();
  readonly checked = model<boolean>(false);

  //state values
  readonly disabled = input<boolean>(false);
  readonly disabledReasons = input<readonly WithOptionalFieldTree<DisabledReason>[]>([]);
  readonly readonly = input<boolean>(false);
  readonly hidden = input<boolean>(false);
  readonly invalid = input<boolean>(false);
  readonly errors = input<readonly WithOptionalFieldTree<ValidationError>[]>([]);

  //metadata values
  readonly name = input<string>('');

  //constraint values
  readonly required = input<boolean>(false);

  toggle() {
    if (this.readonly()) return;
    this.checked.update((val) => !val);
  }
}
